import OpacityHover from '../../js/opacityHover.js'

export function MapButtonHoverInit () {
  const CtaContainers = document.querySelectorAll('[data-map-result-container]')
  
  if(!CtaContainers.length) return

  const opacityHoverInstance = new OpacityHover(CtaContainers)
  opacityHoverInstance.init()
}